import React, { forwardRef }  from "react";

import { Box, IconButton, SvgIconProps } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";

type ButtonIconProps = {
  onClick: () => void;
  color: "primary" | "secondary" | "info" | "error";
  size: string | number;
  Icon: React.ComponentType<SvgIconProps>;
  disabled?: boolean;
  tooltip?: string;
};

const ButtonIcon = forwardRef<HTMLButtonElement, ButtonIconProps>(
  ({
  onClick,
  color,
  size,
  Icon,
  disabled,
  tooltip,
}, ref) => {
  const theme = useTheme();

  const button = (
    <IconButton
      ref={ref}
      color="primary"
      disabled={disabled}
      onClick={onClick}
      sx={{
        color: theme.palette[color].contrastText,
        // backgroundColor: theme.palette[color].main,
        backgroundColor: "transparent",
        "&:hover": {
          // backgroundColor: theme.palette[color].dark
          backgroundColor: alpha(theme.palette[color].main, 0.2),
          borderColor: theme.palette[color].main,
        },
        borderRadius: "4px",
        border: 1,
        borderColor: theme.palette.divider,
        boxShadow: theme.shadows[2],
        height: size,
        width: size,
      }}
    >
      <Icon fontSize="small" color={disabled ? "disabled" : color} />
    </IconButton>
  );

  if (!disabled) {
    return (
      <HelpBox title={tooltip} placement="bottom">
        {button}
      </HelpBox>
    );
  } else {
    return (
      <HelpBox title={tooltip} placement="bottom">
        <Box component="span" sx={{ display: "inline-block", cursor: "none" }}>
          {button}
        </Box>
      </HelpBox>
    );
  }
});

export default ButtonIcon;
